var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "el-dialogOrderChangePopup",
        center: "",
        "append-to-body": "",
        title: "询单详情",
        visible: _vm.dialogVisible,
        width: "55%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.dialogVisible
        ? _c("inquiryInfoCard", {
            ref: "inquiryInfoCard",
            attrs: { allDatas: _vm.allDatas },
            on: { update: _vm.update },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }